import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  deleteButton: {
    color: theme.palette.feedbackError100,
  },
  menuActions: {
    backgroundColor: theme.palette.neutral,
    borderRadius: "12px",
    boxShadow: "0 4px 4pxrgba(0, 0, 0, 0.2)",
    width: "236px",
    border: `1px solid ${theme.palette.neutral200}`,
  },
  menu: {
    padding: "8px 8px",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    borderRadius: "12px",
  },
  textMenuPerfil: {
    color: theme.palette.neutral400,
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "125%",
    letterSpacing: "-0.04px",
    paddingLeft: "16px",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  iconMenu: {
    strokeWidth: "1.6",
    size: "24px",
    color: theme.palette.neutral400,
  },

  menuItem: {
    borderRadius: "12px",
  },
}))

export default useStyles
